<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Accessories</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (serviceToolSelection) {
            <span class="fullWidthConfigurationInput">
              <label for="serviceToolInput" class="halfWidthInputLabel">Service Tool:</label>
              <select
                class="halfWidthInputField"
                #serviceToolInput
                id="serviceToolInput"
                [class.invalidConfigurationSelection]="isInvalidSelection(serviceToolSelection.Name)"
                (change)="selectionChanged(serviceToolSelection, serviceToolInput.value)"
                [value]="serviceToolSelection.Value.toString()">
                @for (allowable of serviceToolSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid"
                    class="configurationSelectionOption"
                    [selected]="serviceToolSelection.Value && serviceToolSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">
                    {{ allowable.Description }}
                  </option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (wallPlateSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(wallPlateSelection.Name)" for="wallPlateInput" class="halfWidthInputLabel">Wall Plate:</label>
              <input
                type="checkbox"
                class="checkboxInput"
                id="wallPlateInput"
                #wallPlateInput
                [checked]="'true' === wallPlateSelection.Value"
                (change)="selectionChanged(wallPlateSelection, wallPlateInput.checked.toString())" />
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (outdoorTempSensorSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(outdoorTempSensorSelection.Name)" for="outdoorTempSensorInput" class="halfWidthInputLabel">
                Outdoor Temperature Sensor:
              </label>
              <input
                type="checkbox"
                class="checkboxInput"
                id="outdoorTempSensorInput"
                #outdoorTempSensorInput
                [checked]="'true' === outdoorTempSensorSelection.Value"
                (change)="selectionChanged(outdoorTempSensorSelection, outdoorTempSensorInput.checked.toString())" />
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (compressorSoftStartKitSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(compressorSoftStartKitSelection.Name)" for="compressorSoftStartKitInput" class="halfWidthInputLabel">
                Compressor Soft Start Kit:
              </label>
              <input
                type="checkbox"
                class="checkboxInput"
                id="compressorSoftStartKitInput"
                #compressorSoftStartKitInput
                [checked]="'true' === compressorSoftStartKitSelection.Value"
                (change)="selectionChanged(compressorSoftStartKitSelection, compressorSoftStartKitInput.checked.toString())" />
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (extendedWarrantySelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(extendedWarrantySelection.Name)" for="extendedWarrantyInput" class="halfWidthInputLabel">
                Extended Warranty:
              </label>
              <input
                type="checkbox"
                class="checkboxInput"
                id="extendedWarrantyInput"
                #extendedWarrantyInput
                [checked]="'true' === extendedWarrantySelection.Value"
                (change)="selectionChanged(extendedWarrantySelection, extendedWarrantyInput.checked.toString())" />
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
